/** /champion-week serializes CRM DATE fields as UTC-midnight instants.
 * Format their calendar day in UTC so a rep west of Greenwich does not see
 * the previous day's championship. Detection/search timestamps remain local. */
export function formatHeldDay(value, locale) {
  if (!value) return null
  const date = new Date(value)
  if (!Number.isFinite(date.getTime())) return null
  return date.toLocaleDateString(locale, {
    weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC',
  })
}
